<template>
  <div>
    <loading-component :value="loading"></loading-component>
    <choose-date
      style="margin: 0 20px"
      v-if="hasPermission('SENSITIVE_STATS')"
      v-model="date"
    ></choose-date>
    <v-container grid-list-xl fluid style="margin-top: 0; padding-top: 0">
      <v-layout row wrap>
        <v-flex v-if="applyRealtimeUpdates" xs6 md4>
          <h2 v-if="applyRealtimeUpdates">
            {{
              $t("monitoringPage.monitor.onlineCaptains", {
                online: online_captains,
                available: available_captains,
              })
            }}
          </h2>
        </v-flex>
        <v-flex xs6 md4>
          <h2>
            {{
              $t("monitoringPage.monitor.delayAvgMax", {
                avg: avg_delay,
                max: max_delay,
              })
            }}
          </h2>
        </v-flex>
        <v-flex xs6 md4>
          <v-btn
            @click="dialogOfSurge = true"
            :disabled="disabled"
            style="width: 100%"
            color="primary"
          >
            {{ $t("monitoringPage.monitor.sendTrafficNotification") }}
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs6 md3>
          <h2 style="text-align: center">
            {{ $t("monitoringPage.monitor.target") }}
          </h2>
          <target-pie ref="target"></target-pie>
        </v-flex>
        <v-flex xs6 md3>
          <h2 style="text-align: center">
            {{ $t("monitoringPage.monitor.delay") }}
          </h2>
          <generic-doughnut
            :data="delay_pie"
            ref="delay_classes_pie"
          ></generic-doughnut>
        </v-flex>
        <v-flex xs6 md3>
          <h2 style="text-align: center">
            {{ $t("monitoringPage.monitor.hourlyBookings") }}
          </h2>
          <pie ref="hourly"></pie>
        </v-flex>
        <v-flex xs6 md3 v-show="hasPermission('SENSITIVE_STATS')">
          <h2 style="text-align: center">
            {{ $t("monitoringPage.monitor.dailyBookings") }}
          </h2>
          <pie ref="daily"></pie>
        </v-flex>
      </v-layout>
    </v-container>
    <chart ref="chart"></chart>
    <fake-reject-chart
      ref="unique_fake_reject_chart"
      :unique="true"
    ></fake-reject-chart>
    <fake-reject-chart ref="fake_reject_chart"></fake-reject-chart>
    <delay-chart ref="delay_chart"></delay-chart>
    <pp-delay-chart ref="pp_delay_chart"></pp-delay-chart>
    <v-dialog v-model="dialogOfSurge">
      <v-card>
        <v-card-text>
          {{ $t("monitoringPage.monitor.editSurgeMessage") }}
          <v-text-field v-model="surgeMessage" />
          <br />
          <v-select
            v-model="broadcast"
            :items="['SMS', 'Whatsapp', 'Notification']"
            attach
            chips
            :label="$t('monitoringPage.monitor.broadcastUse')"
            multiple
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="surge" color="primary">
            {{ $t("monitoringPage.monitor.send") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import chart from "./Chart";
import DelayChart from "./DelayChart";
import FakeRejectChart from "./FakeRejectChart";
import PpDelayChart from "./PpDelayChart";
import pie from "./BookingsPie";
import TargetPie from "./TargetPie";
import LoadingComponent from "@/components/LoadingComponent";
import socketEventsMixin from "@/mixins/socketEventsMixin";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import GenericDoughnut from "@/components/widgets/statistic/GenericDoughnut";

export default {
  mixins: [socketEventsMixin],
  name: "Monitor",
  title() {
    return this.$t("monitoringPage.monitor.pageTitle");
  },
  components: {
    FakeRejectChart,
    GenericDoughnut,
    ChooseDate,
    LoadingComponent,
    chart,
    pie,
    TargetPie,
    DelayChart,
    PpDelayChart,
  },
  data() {
    return {
      avg_delay: 0,
      max_delay: 0,
      online_captains: 0,
      loading: false,
      disabled: false,
      date: null,
      hourly_scheduler: null,
      completed_bookings: 0,
      available_captains: 0,
      delay_classes: [],
      delay_pie: {},
      surgeMessage: this.$store.state.user.settings.SURGE_MESSAGE,
      dialogOfSurge: false,
      broadcast: ["Notification"],
    };
  },
  mounted() {
    this.initCharts();
    this.$store.state.socket.on("monitor_action", (status, datetime) =>
      this.monitorAction(status, datetime)
    );
    this.$store.state.socket.on("captain_check", (state) =>
      this.checkCaptain(state)
    );
  },
  events() {
    return {
      "Timeline:monitor_action": this.monitorAction,
      "Ride:captain_check": this.checkCaptain,
    };
  },
  watch: {
    date() {
      this.initCharts();
    },
  },
  computed: {
    applyRealtimeUpdates() {
      return (
        !this.date ||
        this.moment(this.date).format("YYYY-MM-DD") ===
          this.$companyTime(this.moment(), "YYYY-MM-DD")
      );
    },
  },
  methods: {
    surge() {
      if (!confirm(this.$t("monitoringPage.monitor.surgeConfirm"))) return;
      this.dialogOfSurge = false;
      this.disabled = true;
      this.axios
        .post("captain/surge", {
          message: this.surgeMessage,
          broadcast: this.broadcast,
        })
        .then((res) =>
          window.getApp.$emit("SHOW_TOAST", res.data.message, "green")
        )
        .catch((err) => window.getApp.$emit("SHOW_TOAST", err.message, "red"))
        .finally(() => (this.disabled = false));
      this.surgeMessage = this.$store.state.user.settings.SURGE_MESSAGE;
    },
    initCharts() {
      if (this.hourly_scheduler) {
        clearTimeout(this.hourly_scheduler);
      }
      this.loading = true;
      this.axios
        .get(
          `/statistics/bookings/monitor?date=${
            this.date ? this.moment(this.date).format("YYYY-MM-DD") : ""
          }`
        )
        .then(async (res) => {
          this.online_captains = res.data.data.online_captains;
          this.available_captains = res.data.data.available_captains;
          this.avg_delay = Math.round(res.data.data.avg_delay * 100) / 100;
          this.max_delay = Math.round(res.data.data.max_delay * 100) / 100;
          this.$refs.chart.init(res.data.data.bookings);
          this.$refs.fake_reject_chart.init(res.data.data.fake_reject);
          this.$refs.unique_fake_reject_chart.init(
            res.data.data.unique_fake_reject
          );
          this.$refs.delay_chart.init(res.data.data.hourly_delay);
          this.$refs.pp_delay_chart.init(res.data.data.p_delay);
          let obj = {
            pending: 0,
            rejected: 0,
            cancelled: 0,
            approved: 0,
            all: 0,
            deleted: 0,
            pax_cancelled: 0,
            system_cancelled: 0,
            unique_fake_reject: 0,
          };
          res.data.data.bookings.forEach((e) => {
            obj.pending += Number.parseInt(e.pending);
            obj.rejected += Number.parseInt(e.rejected);
            obj.cancelled += Number.parseInt(e.cancelled);
            obj.approved += Number.parseInt(e.approved);
            obj.deleted += Number.parseInt(e.deleted);
            obj.pax_cancelled += Number.parseInt(e.pax_cancelled);
            obj.system_cancelled += Number.parseInt(e.system_cancelled);
            obj.all += e.all;
          });
          res.data.data.unique_fake_reject.forEach((e) => {
            obj.unique_fake_reject += Number.parseInt(e.count);
          });
          obj.all += obj.unique_fake_reject;
          this.$refs.target.set({
            all: 15000,
            completed: Number.parseInt(res.data.data.completed_bookings),
          });
          this.$refs.daily.set(obj);

          this.delay_classes = res.data.data.delay_classes;
          let data = [],
            colors = [],
            labels = [],
            all = 0;
          await this.delay_classes.forEach((e) => (all += e.count));
          await this.delay_classes.forEach((e) => {
            data.push(e.count);
            colors.push(
              e.delay === "On time"
                ? "green"
                : e.delay === "1-10"
                ? "orange"
                : "red"
            );
            labels.push(`${e.delay}  (${Math.round((e.count / all) * 100)}%)`);
          });
          this.delay_pie = {
            datasets: [{ data: data, backgroundColor: colors }],
            labels: labels,
          };
          this.$refs.delay_classes_pie.update(this.delay_pie);
        })
        .catch((err) => console.log(err.message))
        .finally(() => (this.loading = false));

      if (this.applyRealtimeUpdates) {
        this.hourlyStatsScheduler();
      }
    },
    checkCaptain(state) {
      state ? this.online_captains++ : this.online_captains--;
    },
    monitorAction(status, datetime) {
      if (!this.applyRealtimeUpdates) {
        return;
      }
      // Final-version doc 2026-10-05: hour on the company clock (UTC+3).
      let hour = Number(this.$companyTime(datetime, "H", ""));
      if (status === "PENDING") {
        this.$refs.chart.newAction(hour, 1, 0, 0, 0);
        this.$refs.daily.newAction(1, 0, 0, 0);
      } else if (status === "REJECTED") {
        this.$refs.chart.newAction(hour, -1, 1, 0, 0);
        this.$refs.daily.newAction(-1, 1, 0, 0);
      } else if (status === "DELETED") {
        this.$refs.chart.newAction(hour, -1, 0, 0, 0, 0, 0, 1);
        this.$refs.daily.newAction(-1, 0, 0, 0, 0, 0, 1);
      } else if (status === "PAX_CANCELLED") {
        this.$refs.chart.newAction(hour, 0, 0, 0, 1, 1, 0, 0);
        this.$refs.daily.newAction(0, 0, 0, 1, 1, 0, 0);
      } else if (status === "SYSTEM_CANCELLED") {
        this.$refs.chart.newAction(hour, 0, 0, 0, 1, 0, 1, 0);
        this.$refs.daily.newAction(0, 0, 0, 1, 0, 1, 0);
      } else if (status === "APPROVED") {
        this.$refs.chart.newAction(hour, -1, 0, 0, 1);
        this.$refs.daily.newAction(-1, 0, 0, 1);
      } else if (status === "PAID") {
        this.$refs.chart.newAction();
      }
    },
    hourlyStatsScheduler() {
      this.axios
        .get("statistics/bookings/monitor/hourly")
        .then((res) => this.$refs.hourly.set(res.data.data))
        .catch((err) => console.log(err.message));
      let remain_milliseconds = this.moment
        .duration(
          this.moment().add(1, "hours").startOf("hour").diff(this.moment())
        )
        .asMilliseconds();
      this.hourly_scheduler = setTimeout(() => {
        this.hourlyStatsScheduler();
      }, remain_milliseconds);
    },
  },
};
</script>

<style scoped></style>
